
export const kycStatusMap = {
    KYC_LINK_PENDING : "KYC Link Pending",
    KYC_LINK_GENERATED : "KYC Link Generated",
    KYC_COMPLETE : "KYC Completed",
    VALIDATOR_APPROVAL_PENDING : "Validator Approval Pending",
    KYC_REQUEST_ACCEPTED : "Validator accepted",
    KYC_REQUEST_REJECTED : "validator rejected",
};

export const ProductStatus = {
    VALIDATION_PENDING : "Validation Pending",
    VALIDATION_IN_PROGRESS:"Validation In Progress",
    VALIDATION_NOT_COMPLETED:"Validation Not Completed",
}

export const OrderStatus = {
    VALIDATION_PENDING : "Validation Pending",
    VALIDATION_IN_PROGRESS:"Validation In Progress",
    VALIDATION_REQUEST_SENT:"Validation Pending",
    VALIDATION_NOT_COMPLETED:"Validation Not Completed",
    VALIDATED:"Validated",
    PAYMENT_PENDING : "Payment Pending",
    PAYMENT_NOT_COMPLETED : "Payment Not Completed",
    PAYMENT_COMPLETED : "Payment Completed",
    EXPIRED : "Expired",
    SOLD : "Sold",
}

export const SortBy = {
    createdAt : "Creation Date",
    name :"Product Name",
    bidDurationDays : "Bid Duration"
}

export const SortingOrder = {
    "1": "Ascending",
    "-1": "Descending"
}


export const transactionStatus = {
    PENDING : "Pending",
    SUCCESS : "Success",
    AWAITING_WEBHOOK : "In Progresss",
    FAILED : "Failed",
};
